module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zigbee-controller-list"
  }, [_c('ul', [_c('li', [_c('hub', {
    attrs: {
      "name": "ZigBee Mini网关",
      "id": "5C:FF:FF:E2:00:85",
      "button-text": "添加"
    },
    on: {
      "buttonClick": _vm.addHubClick
    }
  })], 1), _vm._v(" "), _c('li', [_c('hub', {
    attrs: {
      "name": "ZigBee Mini网关",
      "id": "5C:FF:FF:E2:00:86",
      "desc": "已被其他账号添加"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d8d879a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/zigbee/Hub_list.vue
// module id = 874
// module chunks = 1